import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unreadCount: 0,
  realtimeNotifications: [], // Store last 10 real-time notifications
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: (state, action) => {
      // Add new notification to the beginning of the array
      state.realtimeNotifications.unshift(action.payload);

      // Keep only the last 10 notifications
      if (state.realtimeNotifications.length > 10) {
        state.realtimeNotifications = state.realtimeNotifications.slice(0, 10);
      }

      // Increment unread count if the notification is for this user
      if (!action.payload.isRead) {
        state.unreadCount += 1;
      }
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    decrementUnreadCount: (state) => {
      if (state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },
    markNotificationAsRead: (state, action) => {
      const notificationId = action.payload;
      const notification = state.realtimeNotifications.find(
        (n) => n._id === notificationId
      );
      if (notification && !notification.isRead) {
        notification.isRead = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    clearRealtimeNotifications: (state) => {
      state.realtimeNotifications = [];
    },
  },
});

export const {
  addNotification,
  setUnreadCount,
  decrementUnreadCount,
  markNotificationAsRead,
  clearRealtimeNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;

// Selectors
export const selectUnreadCount = (state) => state.notifications.unreadCount;
export const selectRealtimeNotifications = (state) =>
  state.notifications.realtimeNotifications;
